import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const MY_COURSE_ACCESS = 'MY_COURSE_ACCESS';
export const FETCH_COURSES_OVERVIEW = 'FETCH_COURSES_OVERVIEW';
export const FEATURED_COURSES = 'FEATURED_COURSES';
export const ALL_COURSES = 'ALL_COURSES';
export const SINGLE_COURSES_DETAILS = 'SINGLE_COURSES_DETAILS';
export const MODAL_LESSON_PREVIEW = 'MODAL_LESSON_PREVIEW';

export function fetchMyCourses(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/mycourses`;
  var body = { appuserid: session.userid, eventid: session.eventid };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({ type: MY_COURSE_ACCESS, payload: response.resource });
        callback({ success: 1, data: response.resource });
      },
      error => {
        // callback({success: 0, message: error});
      }
    );
  };
}

export function clearMyCourses() {
  return dispatch => {
    dispatch({ type: MY_COURSE_ACCESS, payload: [] });
  };
}

export function fetchOverviewCourses(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/courseoverview`;
  var body = {
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response -> ', response);
        dispatch({ type: FETCH_COURSES_OVERVIEW, payload: response.data });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchFeaturedCourse(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(ispublished=1)AND(isprivate=0)AND(isfeatured=1)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?fields=courseid,coursename,coverimage,covervideo,covervideothumbnail,description&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FEATURED_COURSES, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function searchFeaturedCourse(session, search, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(ispublished=1)AND(isprivate=0)AND(isfeatured=1)`
  );
  let searchQuery = `(coursename CONTAINS ${search})`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?fields=courseid,coursename,coverimage,covervideo,covervideothumbnail,description&filter=(${filter}AND${searchQuery})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FEATURED_COURSES, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function fetchAllCourse(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(ispublished=1)AND(isprivate=0)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?fields=courseid,coursename,coverimage,covervideo,covervideothumbnail,description&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: ALL_COURSES, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function searchAllCourse(session, search, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(ispublished=1)AND(isprivate=0)`
  );
  let searchQuery = `(coursename CONTAINS ${search})`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?fields=courseid,coursename,coverimage,covervideo,covervideothumbnail,description&filter=(${filter}AND${searchQuery})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: ALL_COURSES, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function defaultSingleCourseDetails(data) {
  return dispatch => {
    dispatch({ type: SINGLE_COURSES_DETAILS, payload: data });
  };
}

export function singleCourseDetails(session, courseid, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid})AND(courseid=${courseid})`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/course?related=course_chapter_by_courseid,course_lessons_by_courseid,speaker_by_sessionspeakers,tickets_by_ticketid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: SINGLE_COURSES_DETAILS, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
}

export function applyCoupon(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/couponapply`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          callback({ success: 1, data: response });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function makeStripePayment(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/buyproduct`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          dispatch(fetchMyCourses(session));
          callback({ success: 1 });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function freeProductAccess(session, data, callback) {
  var url = `${INSTANCE_URL}/api/v2/koachifyscript/freeproductaccess`;
  var body = { ...data };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.code == 1) {
          dispatch(fetchMyCourses(session));
          callback({ success: 1 });
        } else {
          callback({ success: response.code, message: response.message });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openLessonPreviewModal(value) {
  return dispatch => {
    dispatch({ type: MODAL_LESSON_PREVIEW, payload: value });
  };
}
